import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summary-card',
  templateUrl: './summary-card.component.html',
  styleUrls: ['./summary-card.component.scss'],
})
export class SummaryCardComponent {
  @Input() icon = 'pi-wallet';
  @Input() label = '';
  @Input() value = '';
  @Input() inactive = false;
}
